import useSWR from "swr";
import { MyDashboardApi } from "../../../apis";
import type { DashboardData, DashboardFilters } from "../../../apis/myDashboard";

// One SWR fetch for the whole dashboard. The active filters form the key, so
// changing either revalidates every widget at once; mutate() force-refreshes.
export function useDashboard(filters: DashboardFilters) {
  const key = `swr.my.dashboard.${filters.month ?? ""}.${filters.startDate ?? ""}.${filters.endDate ?? ""}`;
  return useSWR<DashboardData>(
    key,
    () => MyDashboardApi.getMy(filters),
    { revalidateOnFocus: false }
  );
}
